export const PAGE_TITLE_PREFIX = 'Algorithm Visual Debugger'